import { Component, Prop, Vue } from "vue-property-decorator";
import { DashboardCard } from "../../models/DashboardCard";

@Component({
  name: "DashboardItemLink"
})
export default class DashboardItemLink extends Vue {
  @Prop() child!: DashboardCard;

  iscollapse = true;
}
